// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { useOutletContext } from 'react-router';

export interface PatientListOutletContext {
  openSwitchPatient: () => void;
  isMobile: boolean;
}

const FALLBACK_CONTEXT: PatientListOutletContext = {
  openSwitchPatient: () => {
    // no-op
  },
  isMobile: false,
};

export function usePatientListOutletContext(): PatientListOutletContext {
  const ctx = useOutletContext<PatientListOutletContext | null>();
  return ctx ?? FALLBACK_CONTEXT;
}
